module.exports = __webpack_public_path__ + "img/non_inventory.3a79bcba.png";